import {
  dashboardGroups,
  dashboardTableHeadersPatients,
  dashboardTableHeadersStudies
} from "@/js/preferences";

const initialFilter = {
  patients: {
    patientName: "",
    patientId: "",
    birthDate: "",
    gender: "",
    customTag: ""
  },
  studies: {
    accessionNumber: "",
    studyDate: "",
    modality: "",
    patientName: "",
    customTag: ""
  }
};
const getInitialSearchMeta = () => ({
  mode: "",
  parsed: { tokens: [], warnings: [], free_text_terms: [] },
  warnings: [],
  suggestions: { prefixes: [] },
  counts: { patients: 0, studies: 0, items: 0 }
});
const getInitialState = () => ({
  groupIndex: 0,
  search: "",
  searchLogic: "and",
  searchFilters: initialFilter,
  searchMeta: getInitialSearchMeta(),
  selection: [],
  uploadingData: [],
  headers: {
    patients: dashboardTableHeadersPatients,
    studies: dashboardTableHeadersStudies
  },
  isRefreshing: false,
  // Series display settings
  hideForProcessingSeries: true,
  groupProjRawSeries: true
});

export default {
  namespaced: true,
  state: getInitialState(),
  getters: {
    group: state => dashboardGroups[state.groupIndex],
    groups: () => dashboardGroups,
    searchFilters: state => state.searchFilters,
    searchMeta: state => state.searchMeta,
    numberOfSelectedSeries: state =>
      state.selection.reduce((sum, d) => sum + d.series.length, 0),
    isUploading: state => {
      if (
        state.uploadingData &&
        state.uploadingData.length &&
        state.uploadingData.length > 0
      ) {
        return true;
      } else {
        return false;
      }
    },
    isRefreshing: state => state.isRefreshing,
    uploadingData: state => state.uploadingData,
    hideForProcessingSeries: state => state.hideForProcessingSeries,
    groupProjRawSeries: state => state.groupProjRawSeries
  },

  mutations: {
    reset: state => {
      const s = getInitialState();
      Object.keys(s).forEach(key => (state[key] = s[key]));
    },
    resetAllFilters: state => (state.searchFilters = initialFilter),
    updateGroup: (state, index) => (state.groupIndex = index),
    updateSearch: (state, value) => (state.search = value),
    updateSearchLogic: (state, value) =>
      (state.searchLogic = value === "or" ? "or" : "and"),
    setSearchMeta: (state, value) => {
      state.searchMeta = {
        ...getInitialSearchMeta(),
        ...(value || {})
      };
    },
    resetSearchMeta: state => {
      state.searchMeta = getInitialSearchMeta();
    },
    updateSelection: (state, value) => (state.selection = value),
    upateUploadingData: (state, value) => {
      state.uploadingData = [...state.uploadingData, ...value];
    },
    updatePatientHeaders: (state, value) => (state.headers.patients = value),
    updateStudiesHeaders: (state, value) => (state.headers.studies = value),
    resetUploading: state => {
      state.uploadingData.splice(0);
    },
    setFilter: (state, { key, value }) => {
      state.searchFilters[key[0]][key[1]] = value;
    },
    resetFilter: (state, key) => {
      state.searchFilters[key[0]][key[1]] = "";
    },
    terminateUploading: (state, value) => {
      if (value) {
        if (
          state.uploadingData &&
          state.uploadingData.length &&
          state.uploadingData.length > 0
        ) {
          let uploadingData = state.uploadingData.filter(
            i => i.uniqueUID !== value
          );
          state.uploadingData = uploadingData;
        }
      }
    },
    setRefreshing: (state, isRefreshing) => (state.isRefreshing = isRefreshing),
    setHideForProcessingSeries: (state, value) =>
      (state.hideForProcessingSeries = value),
    setGroupProjRawSeries: (state, value) => (state.groupProjRawSeries = value)
  }
};
